import base from "/Users/mehakpreetsingh/Documents/NextJs App/monochrome/images/apple.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");